<template>
    <dialog-modal v-if="$page.props.auth.check" :show="show" max-width="md" @close="close">
        <template #content>
            <div>
                <div class="flex items-center justify-end -mr-2 -mt-2">
                    <modal-close @close="close" />
                </div>

                <div class="flex items-center justify-center mx-auto w-12 h-12 bg-green-100 rounded-full">
                    <!-- Heroicon name: outline/check -->
                    <svg class="w-6 h-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                <div class="mt-3 text-center sm:mt-5">
                    <h3 class="text-gray-900 text-lg font-medium leading-6" id="modal-title">Payment Successful</h3>
                    <div class="mt-2 text-gray-600 text-sm">
                        <p>{{ amount }} tokens have been added to your wallet.</p>
                        <p>Your new token balance is {{ $page.props.user.wallet.balance | toLocaleString }}.</p>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <jet-button @click.native="close" class="w-full"> Close </jet-button>
        </template>
    </dialog-modal>
</template>

<script>
import DialogModal from "@/Jetstream/DialogModal"
import ModalClose from "@/Components/ModalClose"
import JetButton from "@/Jetstream/Button"

export default {
    name: "BuyTokensSuccessfulModal",
    components: { JetButton, ModalClose, DialogModal },
    props: {
        show: {
            required: true,
            type: Boolean,
        },
        amount: {
            required: true,
            type: String | Number,
        },
    },

    methods: {
        close() {
            this.$emit("update:show", false)
        },
    },
}
</script>
